import React from 'react';
import { Link } from 'react-router-dom';
import {
  HomeIcon,
  ShoppingBagIcon,
  InformationCircleIcon,
  UserGroupIcon,
} from '@heroicons/react/24/outline';
import NavbarCategoryMenu from './NavbarCategoryMenu';
import type { NavCategoryLink } from './NavbarCategoryMenu';

interface NavbarDesktopNavProps {
  categoriesOpen: boolean;
  onToggleCategories: () => void;
  categoryLinks: NavCategoryLink[];
}

/** Iconos solo desde xl para que en laptop quepan en una sola fila. */
const iconClass = 'hidden h-4 w-4 shrink-0 xl:block xl:h-5 xl:w-5';

const linkClass =
  'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg px-2.5 py-2 text-[13px] font-medium text-white/92 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-400/80 xl:gap-2 xl:px-3 xl:text-sm';

const NavbarDesktopNav: React.FC<NavbarDesktopNavProps> = ({
  categoriesOpen,
  onToggleCategories,
  categoryLinks,
}) => (
  <div className="flex flex-nowrap items-center justify-center gap-0.5 xl:gap-1" aria-label="Principal">
    <Link to="/" className={linkClass}>
      <HomeIcon className={iconClass} aria-hidden />
      <span>Inicio</span>
    </Link>
    <Link to="/productos" className={linkClass}>
      <ShoppingBagIcon className={iconClass} aria-hidden />
      <span>Productos</span>
    </Link>
    <NavbarCategoryMenu open={categoriesOpen} onToggle={onToggleCategories} items={categoryLinks} />
    <Link to="/emprendedores" className={linkClass}>
      <UserGroupIcon className={iconClass} aria-hidden />
      <span>Emprendedores</span>
    </Link>
    <Link to="/sobre-nosotros" className={linkClass}>
      <InformationCircleIcon className={iconClass} aria-hidden />
      <span>Sobre nosotros</span>
    </Link>
  </div>
);

export default NavbarDesktopNav;
